<template>
  <div class="messages-wrapper">
    <div class="message-container">
      <div class="input-container">
        <BaseSelect
          :key="categorySelectKey"
          :options-list="categoryList"
          :default-value="category"
          :dictionary-path="'message.messagesPage.categoryList.'"
          :label="$t('message.messagesPage.categoryTitle')"
          v-model="category"
          :name="'messageCategory'"
        />
      </div>
      <div v-if="isContractNumberCategory" class="input-container">
        <BaseTextInput
          :label="$t('message.messagesPage.contractNumberTitle')"
          :placeholder="$t('message.messagesPage.contractNumberPlaceholder')"
          :name="'contractNumber'"
          autocomplete="one-time-code"
          v-model="contractNumber"
        />
      </div>
      <template v-if="isLoanRepaymentOutsideServiceCategory">
        <div class="input-container">
          <BaseTextInput
            :label="$t('message.messagesPage.borrowerLastNameTitle')"
            :placeholder="$t('message.messagesPage.borrowerLastNamePlaceholder')"
            :name="'borrowerLastName'"
            v-model="metadata.borrower_last_name"
            autocomplete="one-time-code"
          />
        </div>
        <div class="input-container">
          <BaseTextInput
            :label="$t('message.messagesPage.borrowerFirstNameTitle')"
            :placeholder="$t('message.messagesPage.borrowerFirstNamePlaceholder')"
            :name="'borrowerFirstName'"
            v-model="metadata.borrower_first_name"
            autocomplete="one-time-code"
          />
        </div>
        <div class="input-container">
          <BaseTextInput
            :label="$t('message.messagesPage.borrowerMiddleNameTitle')"
            :placeholder="$t('message.messagesPage.borrowerMiddleNamePlaceholder')"
            :name="'borrowerMiddleName'"
            v-model="metadata.borrower_middle_name"
            autocomplete="one-time-code"
          />
        </div>
        <div class="input-container">
          <BaseSelect
            :options-list="repaymentTypeList"
            :default-value="metadata.repayment_type"
            :dictionary-path="'message.messagesPage.repaymentTypeList.'"
            :label="$t('message.messagesPage.repaymentTypeTitle')"
            :placeholder="$t('message.messagesPage.repaymentTypePlaceholder')"
            v-model="metadata.repayment_type"
            :name="'repaymentType'"
          />
        </div>
        <div class="input-container">
          <BaseTextInput
            :label="$t('message.messagesPage.repaymentAmountTitle')"
            :placeholder="$t('message.messagesPage.repaymentAmountPlaceholder')"
            :name="'repaymentAmount'"
            :type="'number'"
            v-model="metadata.repayment_amount"
            autocomplete="one-time-code"
          />
        </div>
        <div class="input-container">
          <div class="datepicker-input-wrapper">
            <div class="datepicker-label">
              {{ $t('message.messagesPage.repaymentDateTitle') }}
            </div>
            <div class="datepicker-block">
              <BaseDatepicker
                :default-value="metadata.repayment_date"
                :placeholder="$t('message.messagesPage.repaymentDatePlaceholder')"
                :format="'DD.MM.YYYY'"
                :value-type="'YYYY-MM-DD'"
                :range="false"
                :is-has-calendar-icon="true"
                v-model="metadata.repayment_date"
              />
            </div>
          </div>
        </div>
        <div class="input-container">
          <BaseSelect
            :options-list="repaymentMethodList"
            :default-value="metadata.repayment_method"
            :dictionary-path="'message.messagesPage.repaymentMethodList.'"
            :label="$t('message.messagesPage.repaymentMethodTitle')"
            :placeholder="$t('message.messagesPage.repaymentMethodPlaceholder')"
            v-model="metadata.repayment_method"
            :name="'repaymentMethod'"
          />
        </div>
        <div class="input-container">
          <BaseSelect
            :options-list="contractActionList"
            :default-value="metadata.contract_action"
            :dictionary-path="'message.messagesPage.contractActionList.'"
            :label="$t('message.messagesPage.contractActionTitle')"
            :placeholder="$t('message.messagesPage.contractActionPlaceholder')"
            v-model="metadata.contract_action"
            :name="'contractAction'"
          />
        </div>
      </template>
      <div class="input-container message-input-container">
        <BaseTextareaInput
          :label="$t('message.messagesPage.messageTitle')"
          :placeholder="$t('message.messagesPage.placeholder')"
          :name="'supportMessage'"
          :validate-rules="'supportMessage'"
          v-model="message"
          :default-value="message"
        />
      </div>
      <div class="btns-block">
        <div class="btn-container">
          <base-button
            :text="$t('message.messagesPage.btn')"
            :disabled="isBtnDisabled"
            @click="sendMessage()"
          />
        </div>
        <div class="uploader-block">
          <DocsUploader
            :name="'messageFile'"
            @file="addFile"
            :clean-file="cleanFile"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTextareaInput from '../components/base/BaseTextareaInput.vue';
import BaseTextInput from '../components/base/BaseTextInput.vue';
import BaseSelect from '../components/base/BaseSelect.vue';
import BaseDatepicker from '../components/base/BaseDatepicker.vue';
import BaseButton from '../components/base/BaseButton.vue';
import DocsUploader from '../components/common/DocsUploader.vue';

export default {
  name: 'Messages',
  inject: ['$httpService'],
  components: {
    BaseTextareaInput,
    BaseTextInput,
    BaseSelect,
    BaseDatepicker,
    BaseButton,
    DocsUploader
  },
  data() {
    return {
      message: '',
      category: 'other',
      contractNumber: '',
      metadata: {
        repayment_type: '',
        repayment_amount: '',
        repayment_date: '',
        repayment_method: '',
        contract_action: '',
        borrower_last_name: '',
        borrower_first_name: '',
        borrower_middle_name: ''
      },
      repaymentTypeList: ['full', 'partial'],
      repaymentMethodList: [
        'opi',
        'voluntary_to_card',
        'debt_forgiveness',
        'voluntary_by_third_party'
      ],
      contractActionList: [
        'close_loan_agreement',
        'reflect_in_loan_agreement'
      ],
      categorySelectKey: 0,
      file: undefined,
      cleanFile: false
    }
  },
  methods: {
    addFile(file) {
      this.file = file;
    },
    resetMetadata() {
      this.metadata = {
        repayment_type: '',
        repayment_amount: '',
        repayment_date: '',
        repayment_method: '',
        contract_action: '',
        borrower_last_name: '',
        borrower_first_name: '',
        borrower_middle_name: ''
      };
    },
    async sendMessage() {
      if (this.isBtnDisabled) {
        return;
      }

      const payload = new FormData();

      payload.append('message', this.message);
      payload.append('category', this.category);

      if (this.isContractNumberCategory) {
        payload.append('contract_number', this.contractNumber);
      }

      if (this.isLoanRepaymentOutsideServiceCategory) {
        payload.append('metadata', JSON.stringify(this.metadata));
      }

      if (this.file) {
        payload.append('file', this.file);
      }

      try {
        this.$httpService.message.sendMessage(payload);
        this.$toast.success(this.$t('message.messagesPage.tostMsg'));
        this.message = '';
        this.category = 'other';
        this.contractNumber = '';
        this.resetMetadata();
        this.categorySelectKey += 1;
        this.file = undefined; 
        this.cleanFile = !this.cleanFile;
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    ...mapGetters(['profile']),
    categoryList() {
      const categories = ['other', 'loan_conclusion'];

      if (this.profile?.role === 'lender') {
        categories.push('loan_repayment_outside_service');
      }

      return categories;
    },
    isLoanConclusionCategory() {
      return this.category === 'loan_conclusion';
    },
    isLoanRepaymentOutsideServiceCategory() {
      return this.category === 'loan_repayment_outside_service';
    },
    isContractNumberCategory() {
      return this.isLoanConclusionCategory || this.isLoanRepaymentOutsideServiceCategory;
    },
    isContractNumberMissing() {
      return this.isContractNumberCategory && !this.contractNumber.trim();
    },
    isMetadataMissing() {
      return this.isLoanRepaymentOutsideServiceCategory && (
        !this.metadata.repayment_type
        || !this.metadata.repayment_amount.trim()
        || !this.metadata.repayment_date
        || !this.metadata.repayment_method
        || !this.metadata.contract_action
        || !this.metadata.borrower_last_name.trim()
        || !this.metadata.borrower_first_name.trim()
        || !this.metadata.borrower_middle_name.trim()
      );
    },
    isHasEmptyFields() {
      return !this.message.trim()
        || !this.category
        || this.isContractNumberMissing
        || this.isMetadataMissing;
    },
    isHasErrors() {
      return this.errors.items.length > 0;
    },
    isBtnDisabled() {
      return this.isHasEmptyFields || this.isHasErrors;
    }
  },
  watch: {
    category(value) {
      if (!this.isContractNumberCategory) {
        this.contractNumber = '';
      }

      if (value !== 'loan_repayment_outside_service') {
        this.resetMetadata();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .messages-wrapper {
    @include page-wrapper-with-header-and-footer;

    padding-top: 40px;
    box-sizing: border-box;
  }

  .message-container {
    @include base-page-container;

    flex-direction: column;
    color: #121212;
  }

  .input-container {
    width: 50%;
  }

  .datepicker-input-wrapper {
    @include base-input-wrapper;
  }

  .datepicker-label {
    @include base-input-label;
  }

  .datepicker-block {
    width: 100%;
    height: 42px;
  }

  .message-input-container ::v-deep .input-block {
    height: 120px;
  }

  .message-input-container ::v-deep .input {
    height: 100%;
  }

  .btns-block {
    width: 50%;
    margin-bottom: 0;
    display: flex;
    justify-content: space-between;
    flex-direction: column-reverse;
  }

  .btn-container {
    width: 275px;
    height: 60px;
  }

  .uploader-block {
    width: 300px;
    max-width: 90%;
  }

  @media screen and (max-width: 1760px) {
    .input-container,
    .btns-block {
      width: 80%;
    }
  }

  @media screen and (max-width: 965px) {
    .input-container,
    .btns-block {
      width: 100%;
    }
  }

  @media screen and (max-width: 690px) {
    .btns-block {
      flex-direction: column-reverse;
    }
  }
</style>